export default "__VITE_ASSET__5ffe8bf0__"